export const officeOrHomeList = ['確認中', '基本リモート', '週1〜2', '週2〜3', '週3〜4', '週5(常駐)'];
